/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAdditionalOptionsContent_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_user">;
    readonly " $refType": "PdpSharedDescriptionAdditionalOptionsContent_user";
};
export type PdpSharedDescriptionAdditionalOptionsContent_user$data = PdpSharedDescriptionAdditionalOptionsContent_user;
export type PdpSharedDescriptionAdditionalOptionsContent_user$key = {
    readonly " $data"?: PdpSharedDescriptionAdditionalOptionsContent_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDescriptionAdditionalOptionsContent_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user",
      "args": null
    }
  ]
};
(node as any).hash = '862745f2a8b59e551ecc6367246d0c64';
export default node;
